import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './travel.css';
import { Link } from 'react-router-dom';

const categories = [

  {
    title: 'Switzerland',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1756345000/cover6_pwssii.jpg',
    path: '/travel/switzerland',
  },
  {
    title: 'Italy',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1773278741/covers7_jzobhw.jpg',
    path: '/travel/italy',
  },
  {
    title: 'Romania',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1773281542/cover8_htppn7.jpg',
    path: '/travel/romania',
  },
  {
    title: 'Germany',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1750977382/cover5_rx9po4.jpg',
    path: '/travel/germany',
  },
  {
    title: 'Bulgaria',
    image: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1756345000/cover6_pwssii.jpg',
    path: '/travel/bulgaria',
  },
];


function Travel() {
    return (
<div className="containerTravelG">
  <div className='textTravelG'>
    <span className='titleTravelG'>Could not believe my eyes</span> <br/>
    <span>My eyes and my ears are in aww and wow at the same time. Here you will find galeries for each country I've been to.</span>
  </div>
  <div className="category-grid">
        {categories.map((category, index) => (
          <Link to={category.path} key={index} className="category-card">
            <img src={category.image} alt={category.title} className="category-image" />
            <div className="category-overlay">
              <h2 className="category-title">{category.title}</h2>
            </div>
          </Link>
        ))}
      </div>
      
    </div>
  );
}
  
  export default Travel;